<template>
  <div>
    <ShareDetailToolbar/>
    <v-tabs color="wplgrey0" slider-color="wplblue2" v-model="tab">
      <v-tab href="#tab-1">
        <v-tabs-slider color="wplblue0">
        </v-tabs-slider>
        <div class="body wplblue0--text">
          Info
        </div>
      </v-tab>
      <v-tab href="#tab-2">
        <div class="body wplblue0--text">
          Detail
        </div>
      </v-tab>
      <v-tab href="#tab-3">
        <div class="body wplblue0--text">
          Site
        </div>
      </v-tab>
      <v-tab href="#tab-4">
        <div class="body wplblue0--text">
          Scope
        </div>
      </v-tab>
      <v-tab href="#tab-5">
        <div class="body wplblue0--text">
          Result
        </div>
      </v-tab>
      <v-tab href="#tab-6">
        <div class="body wplblue0--text">
          Roles
        </div>
      </v-tab>
      <v-tab href="#tab-7">
        <div class="body wplblue0--text">
          Trans
        </div>
      </v-tab>
      <v-tab href="#tab-8">
        <div class="body wplblue0--text">
          Attach
        </div>
      </v-tab>
      <v-tab href="#tab-9">
        <div class="body wplblue0--text">
          Relps
        </div>
      </v-tab>
      <v-tab href="#tab-10">
        <div class="body wplblue0--text">
          Revs.
        </div>
      </v-tab>
      <!-- Basic / Info -->
      <v-tab-item :key="1" :value="'tab-1'">
        <ShareDetailInfo/>
      </v-tab-item>
      <!-- Char. -->
      <v-tab-item :key="2" :value="'tab-2'">
        <ActionDetailDescribe v-if="this.tab === 'tab-2'"/>
      </v-tab-item>
      <!-- Char. -->
      <v-tab-item :key="3" :value="'tab-3'">
        <ShareDetailSite v-if="this.tab === 'tab-3'"/>
      </v-tab-item>
      <!-- Char. -->
      <v-tab-item :key="4" :value="'tab-4'">
        <ShareDetailScope v-if="this.tab === 'tab-4'"/>
      </v-tab-item>
      <!-- Attachments -->
      <v-tab-item :key="5" :value="'tab-5'">
        <v-container :class="ui.bkgdColor">
          <ShareDetailClose v-if="this.tab === 'tab-5'"/>
        </v-container>
      </v-tab-item>
      <!-- Relps -->
      <v-tab-item :key="6" :value="'tab-6'">
        <v-container :class="ui.bkgdColor" v-if="this.tab === 'tab-6'">
          <Roles/>
        </v-container>
      </v-tab-item>
      <!-- <Transitions/> -->
      <v-tab-item :key="7" :value="'tab-7'">
        <v-container :class="ui.bkgdColor" v-if="this.tab === 'tab-7'">
          <Transitions/>
        </v-container>
      </v-tab-item>
      <v-tab-item :key="8" :value="'tab-8'">
        <v-container :class="ui.bkgdColor" v-if="this.tab === 'tab-8'">
          <Attachments/>
        </v-container>
      </v-tab-item>
      <v-tab-item :key="9" :value="'tab-9'">
        <v-container :class="ui.bkgdColor" v-if="this.tab === 'tab-9'">
          <RelationshipRegister/>
        </v-container>
      </v-tab-item>
      <v-tab-item :key="10" :value="'tab-10'">
        <v-container :class="ui.bkgdColor" v-if="this.tab === 'tab-10'">
          <RevisionDash/>
        </v-container>
      </v-tab-item>
    </v-tabs>
    <DetailChange/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Attachments from "@/document/attachments/components/Attachments";
import Roles from "@/support/roles/components/Roles";
import actionFunctions from "@/business/actions/mixins/actionFunctions.js";
import ShareDetailInfo from "@/support/share/components/ShareDetailInfo";
import ActionDetailDescribe from "@/business/actions/components/ActionDetailDescribe";
import ShareDetailSite from "@/support/share/components/ShareDetailSite";
import ShareDetailScope from "@/support/share/components/ShareDetailScope";
import ShareDetailClose from "@/support/share/components/ShareDetailClose";
import RevisionDash from "@/document/revisions/components/RevisionDash";
import DetailChange from "@/support/detail/components/DetailChange";
import RelationshipRegister from "@/data/list/components/RelationshipRegister";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import Transitions from "@/support/transitions/components/Transitions";
import ShareDetailToolbar from "@/support/share/components/ShareDetailToolbar";

export default {
  components: {
    ActionDetailDescribe,
    ShareDetailInfo,
    ShareDetailSite,
    ShareDetailScope,
    ShareDetailClose,
    DetailChange,
    Roles,
    Attachments,
    RevisionDash,
    RelationshipRegister,
    Transitions,
    ShareDetailToolbar
  },
  // eslint-disable-next-line
  mixins: [
    apptheme,
    actionFunctions
  ],
  data() {
    return {
      valid: true,
      value: "",
      tab: ""
    };
  },
  // mounted() {
  //   // this is used to identify a change in user // new assignee
  //   this.$store.dispatch("changeAction", this.getDetail);
  // },
  beforeDestroy() {
    this.$store.dispatch("changeDocumentRevMod", null);
  },
  // eslint-disable-next-line
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getAttachmentList",
      "getRolesList",
      "getPreviousPage",
      "getDetail",
      "getDataSavePendingIndication"
    ]),
    detail() {
      return this.getDetail;
    },
    dataSavePendingColor() {
      // eslint-disable-next-line
      if (this.getDataSavePendingIndication === true) {
        return "wplorange0";
      } else {
        return this.ui.bkgdColor;
      }
    }
  }
};
</script>
